function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { createContext, useContext, useRef, useState } from "react";
import { allValue } from "./searchFormTypes";
var SearchBarContext = /*#__PURE__*/ createContext(undefined);
export var SearchBarProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(false), 2), isMobileSearchOpen = _useState[0], setIsMobileSearchOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isSecondaryFiltersOpen = _useState1[0], setIsSecondaryFiltersOpen = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isSearchBarRendered = _useState2[0], setSearchBarRendered = _useState2[1];
    var _useState3 = _sliced_to_array(useState(allValue.value), 2), selectedType = _useState3[0], setSelectedType = _useState3[1];
    // Store attributes per type so they persist when switching.
    var pitchAttributesRef = useRef({});
    var accommodationAttributesRef = useRef({});
    var openMobileSearch = function() {
        return setIsMobileSearchOpen(true);
    };
    var closeMobileSearch = function() {
        return setIsMobileSearchOpen(false);
    };
    var openSecondaryFilters = function() {
        return setIsSecondaryFiltersOpen(true);
    };
    var closeSecondaryFilters = function() {
        return setIsSecondaryFiltersOpen(false);
    };
    return /*#__PURE__*/ React.createElement(SearchBarContext.Provider, {
        value: {
            isMobileSearchOpen: isMobileSearchOpen,
            openMobileSearch: openMobileSearch,
            closeMobileSearch: closeMobileSearch,
            isSecondaryFiltersOpen: isSecondaryFiltersOpen,
            openSecondaryFilters: openSecondaryFilters,
            closeSecondaryFilters: closeSecondaryFilters,
            isSearchBarRendered: isSearchBarRendered,
            setSearchBarRendered: setSearchBarRendered,
            selectedType: selectedType,
            setSelectedType: setSelectedType,
            pitchAttributesRef: pitchAttributesRef,
            accommodationAttributesRef: accommodationAttributesRef
        }
    }, children);
};
export var useSearchBar = function() {
    var context = useContext(SearchBarContext);
    if (context === undefined) {
        throw new Error("useSearchBar must be used within a SearchBarProvider");
    }
    return context;
};
